/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import styled from "@emotion/styled";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPython, faJs, faCss3, faReact } from '@fortawesome/free-brands-svg-icons'
import { faHome, faBars } from "@fortawesome/free-solid-svg-icons";


export function PythonIcon(props) {
  return <FontAwesomeIcon {...props} icon={faPython} css={css`color: lightgreen;`}/>
} 

export function JavascriptIcon(props) {
  return <FontAwesomeIcon {...props} icon={faJs} css={css`color: yellow;`}/>
} 

export function HomeIcon(props) {
  return <FontAwesomeIcon {...props} icon={faHome}/>
} 

export function CSSIcon(props) {
  return <FontAwesomeIcon {...props} icon={faCss3} css={css`color: lightcoral;`}/>
} 

export function ReactIcon(props) {
  return <FontAwesomeIcon {...props} icon={faReact} css={css`color: turquoise;`}/>
} 

export function HamburgerIcon(props) {
  return <FontAwesomeIcon {...props} icon={faBars} css={css`color: white;`}/>
} 